// Module
var code = "<div class=\"input-group\"> <input type=\"text\" class=\"form-control\" ng-model=\"vm.numericValue\" id=\"fieldresponse_{{vm.fieldResponse.id}}\" placeholder=\"{{ vm.requiredPlaceholderText | lowercase }}\"> </div> ";
// Exports
module.exports = code;